export default {"src":"/_next/static/media/ULTA.786f6f23.svg","height":18,"width":18};